import Image from "@/components/Image";
import { ModalCenter } from "../../Modals/ModalCenter";
import { menus_mobile_more } from "../data";
import type { MenuType } from "../type";

export function ModalMore(props: {
  activeItem?: MenuType;
  className?: string;
  onSelect: (item?: MenuType) => void;
}) {
  return (
    <ModalCenter
      isVisible={true}
      setIsVisible={() => {
        props.onSelect();
      }}
      clickOutside={() => {
        props.onSelect();
      }}
      title=""
      isHeader={false}
      className="!p-0 max-w-[420px]"
    >
      <div className="grid grid-cols-3 bg-white p-6 mx-2 rounded-2xl gap-x-2 gap-y-7 flex-wrap justify-between pointer-events-auto">
        {menus_mobile_more.map((item) => (
          <button
            type="button"
            key={item.img}
            data-action={item.dataAction}
            className="flex items-center justify-center flex-col gap-1 cursor-pointer"
            onClick={() => {
              props.onSelect(item);
            }}
          >
            <Image src={item.img} className="w-[56px] h-[56px]" />
            <p className="text-black text-sm leading-4 font-medium line-clamp-1">
              {item.label}
            </p>
          </button>
        ))}
      </div>
    </ModalCenter>
  );
}
